/**
 * @ngdoc directive
 * @name WcResponsiveTableModule.directive:wcTablePagination
 * @description
 * The wcTablePagination directive is responsible for pagination operation in datatable
 */


angular.module('WcResponsiveTableModule').directive('wcTablePagination', ['$compile', '$window', '_', function ($compile, $window, _) {
	return {
		require: ['wcTablePagination'],
		scope: {},
		bindToController: {},
		controllerAs: 'tablePaginationController',
		controller: ['$scope', '$element', 'WcTranslateConfiguratorService',
					function ($scope, $element, WcTranslateConfiguratorService) {

			//TODO: The wcResponsiveTable directive is not a parent of wcTablePagination, figure out why?
			// In the mean time, grab the wcResponsiveTable controller off the scope
			var responsiveTableController = $element.parent().controller('wcResponsiveTable');
			responsiveTableController = responsiveTableController || $scope.responsiveTableController || $scope.$parent.responsiveTableController;
			var tableScope = responsiveTableController.WcTableScopeService.getTableScope();
			var pagination;

			this.tableWrapper = responsiveTableController.element;
			this.table = responsiveTableController.table;
			this.id = responsiveTableController.id + '-pagination';


			WcTranslateConfiguratorService.loadPartAndRefresh('WC-dataTable');

			this.pagination = responsiveTableController.WcTablePaginationService.getPaginationDefaults();
			pagination = this.pagination;

			tableScope.$on('table.pagination.update', angular.bind(this, function (event, resetCurrentPage) {
				if (resetCurrentPage) {
					pagination.currentPage = 1;
				}

				pagination.totalItems = responsiveTableController.WcTableCollectionService.getCollectionLength();
				pagination.totalPages = Math.ceil(pagination.totalItems / pagination.resultsPerPage);
				this.updatePaginationControls(pagination.currentPage);
				this.createPaginationControlNumbers();
			}));

			pagination.boundaryLinks = true;
			pagination.currentBreakpoint = '';
			pagination.currentPage = 1;
			pagination.paginationPageControls = [];
			pagination.totalItems = responsiveTableController.WcTableCollectionService.getCollectionLength();
			pagination.totalPages = Math.ceil(pagination.totalItems / pagination.resultsPerPage);

			this.createPaginationControlNumbers = function () {
				var array = [];

				var paginationNoOfPages = pagination.totalPages>pagination.numberOfPageControls? pagination.numberOfPageControls:pagination.totalPages;

				var paginationOffset = Math.floor(paginationNoOfPages / 2);

				for (var index = 0; index < paginationNoOfPages; index++) {
					if (pagination.currentPage - paginationOffset > 0 &&
						pagination.currentPage - paginationOffset <= pagination.totalPages) {
						array.push(pagination.currentPage - paginationOffset);
					}
					paginationOffset--;
				}

				if (array.length < paginationNoOfPages) {
					var checkValue = Math.floor(pagination.currentPage - paginationNoOfPages / 2);
					var numberOfPagesNeeded = Math.abs(array.length - paginationNoOfPages);
					var pageNumberToAdd;
					var i;

					if (checkValue <= 0) {
						var lastPageAdded = array[array.length - 1];
						for (i = 1; i <= numberOfPagesNeeded; i++) {
							pageNumberToAdd = lastPageAdded + i;
							if (pagination.totalPages >= pageNumberToAdd) {
								array.push(pageNumberToAdd);
							}
						}
					} else {
						var firstPageAdded = array[0];
						for (i = 1; i <= numberOfPagesNeeded; i++) {
							pageNumberToAdd = firstPageAdded - i;
							array.unshift(pageNumberToAdd);
						}
					}
				}

				pagination.paginationPageControls = array;
			};

			this.changeResultsPerPage = function () {
				if (pagination.resultsPerPage === 'All') {
					pagination.resultsPerPage = pagination.totalItems;
					pagination.pageStart = 0;
					pagination.pageEnd = pagination.totalItems;
					pagination.totalPages = 1;
					this.changePage(1);

				} else {
					pagination.totalPages = Math.ceil(pagination.totalItems / pagination.resultsPerPage);
					var newPage = Math.ceil(pagination.pageStart / pagination.resultsPerPage);
					this.changePage(newPage ? newPage : 1);
				}
			};

			this.updatePaginationControls = function (pageNumber) {
				pagination.currentPage = pageNumber;
				pagination.pageStart = (pageNumber * pagination.resultsPerPage) - pagination.resultsPerPage;

				var newPageEnd = pagination.pageStart + pagination.resultsPerPage;

				if (newPageEnd > pagination.totalItems) {
					pagination.pageEnd = pagination.totalItems;
				} else {
					pagination.pageEnd = newPageEnd;
				}

				responsiveTableController.WcTablePaginationService.setPaginationDefaults({
					pageStart: pagination.pageStart,
					pageEnd: pagination.pageEnd
				});

			};

			this.changePage = function (pageNumber) {
				if (pageNumber > 0 && pageNumber <= pagination.totalPages) {
					this.updatePaginationControls(pageNumber);
					this.createPaginationControlNumbers();

					tableScope.renderTable();

				} else {
					if (isNaN(pageNumber)) {
						throw 'Invaild Page Number: ' + pageNumber + '. Must be a number, no other characters allowed';
					}

					else if (pageNumber <= 0) {
						throw 'Invaild Page Number: ' + pageNumber + '. Must be greater than 0';
					}

					else if (pageNumber > pagination.totalPages) {
						throw 'Invaild Page Number: ' + pageNumber + '. Must be smaller than ' + pagination.totalPages;
					}

					else {
						throw 'Invaild Page Number: ' + pageNumber + '. Not sure what you did, but it is invalid';
					}
				}
			};

			this.nextPage = function () {
				var nextPageNumber = pagination.currentPage;
				if (nextPageNumber + 1 <= pagination.totalPages) {
					this.changePage(++nextPageNumber);
				}
			};

			this.previousPage = function () {
				var nextPageNumber = pagination.currentPage;
				if (nextPageNumber - 1 > 0) {
					this.changePage(--nextPageNumber);
				}
			};

			//// Make sure the pagination controls are refreshed after a sort. If the table is sorted on a page greater
			//// than 1, the controls will not update
			//tableScope.$on('table.sort.complete', function() {
			//	this.updatePaginationControls(1);
			//	this.createPaginationControlNumbers();
			//
			//	tableScope.$broadcast('table.render.start', pagination);
			//});

			//responsive stuff
			tableScope.$watch(function () {
				return pagination.currentBreakpoint;
			}, angular.bind(this, function (newValue, oldValue) {
				if (newValue !== oldValue) {
					if (newValue === 'xs') {
						//pagination.resultsPerPage = 'All';
						//this.changeResultsPerPage();
						pagination.numberOfPageControls = 0;
						pagination.boundaryLinks = false;
					}
					else if (newValue === 'sm') {
						//pagination.resultsPerPage = this.resultsPerPage || pagination.resultsPerPage;
						//this.changeResultsPerPage();
						pagination.numberOfPageControls = 0;
						pagination.boundaryLinks = false;
					}
					else if (newValue === 'md') {
						//pagination.resultsPerPage = this.resultsPerPage || pagination.resultsPerPage;
						//this.changeResultsPerPage();
						pagination.numberOfPageControls = 0;
						pagination.boundaryLinks = false;
					}
					else if (newValue === 'lg') {
						//pagination.resultsPerPage = this.resultsPerPage || pagination.resultsPerPage;
						//this.changeResultsPerPage();
						pagination.numberOfPageControls = 3;
						pagination.boundaryLinks = true;
					}
					else {
						pagination.numberOfPageControls = responsiveTableController.WcTablePaginationService.getPaginationDefaults().numberOfPageControls;
						pagination.boundaryLinks = true;
					}
					this.createPaginationControlNumbers();
				}
			}));

			var resizeHandler = function () {
				//<=430 is default
				if (window.innerWidth <= pagination.responsiveBreakpoints[0] && pagination.currentBreakpoint !== 'xs') {
					pagination.currentBreakpoint = 'xs';
				}
				//>430 and <=500 is default
				else if ((window.innerWidth > pagination.responsiveBreakpoints[0] &&
					window.innerWidth <= pagination.responsiveBreakpoints[1]) && pagination.currentBreakpoint !== 'sm') {
					pagination.currentBreakpoint = 'sm';
				}
				//>500 and <=600 is default
				else if ((window.innerWidth > pagination.responsiveBreakpoints[1] &&
					window.innerWidth <= pagination.responsiveBreakpoints[2]) && pagination.currentBreakpoint !== 'md') {
					pagination.currentBreakpoint = 'md';
				}
				//>600 and <=900 is default
				else if ((window.innerWidth > pagination.responsiveBreakpoints[2] &&
					window.innerWidth <= pagination.responsiveBreakpoints[3]) && pagination.currentBreakpoint !== 'lg') {
					pagination.currentBreakpoint = 'lg';
				}
				//>900 is default
				else if (window.innerWidth > pagination.responsiveBreakpoints[3] && pagination.currentBreakpoint !== 'xl') {
					pagination.currentBreakpoint = 'xl';
				}

				tableScope.$digest();
			};
			//debounce this handler to avoid rapid-fire resize events
			angular.element($window).bind('resize', _.debounce(resizeHandler, 300));

			//finally, call the resizeHandler once to initialize our breakpoint var
			setTimeout(resizeHandler, 0);
		}],
		link: function (scope, element, attr, controllers) {
			var tablePaginationController = controllers[0];

			var resultsPerPageTemplate = [
				'<div class="col-xs-3 result-page-count">',
				'<label>{{"pagination.resultsPerPage" | translate}}: ',
				'<select class="form-control form-inline input-sm pagination-results-per-page" ng-options="result for result in tablePaginationController.pagination.selectResultsPerPage"',
				'ng-model="tablePaginationController.pagination.resultsPerPage" ng-change="tablePaginationController.changeResultsPerPage()">',
				'</select></label>',
				'</div>'].join('');

			var paginationLegendTemplate = [
				'<div class="col-xs-4 text-right">',
				'<p class="hidden-xs hidden-sm results-data"><span ng-if="tablePaginationController.pagination.totalItems==0">{{"pagination.paginationNoRecordLegend" | translate:tablePaginationController.pagination}}</span><span ng-if="tablePaginationController.pagination.totalItems>0"> {{"pagination.paginationLegend" | translate:tablePaginationController.pagination}}</span>',
				'</p>',
				'</div>'].join('');

			var paginationControlsTemplate = [
				'<div class="col-xs-5 pagination-control text-right">',
				'<ul class="hidden-xs pagination pagination-sm">',
				'<li ng-hide="!tablePaginationController.pagination.boundaryLinks" class="pagination-page"  ng-class="{disabled: tablePaginationController.pagination.currentPage == 1}"><button type="button" ng-disabled="tablePaginationController.pagination.currentPage == 1" ng-click="tablePaginationController.changePage(1)">&#xe069</button></li>',
				'<li class="pagination-page"  ng-class="{disabled: tablePaginationController.pagination.currentPage == 1}"><button type="button"  ng-disabled="tablePaginationController.pagination.currentPage == 1" class="previous" ng-click="tablePaginationController.previousPage()">&#xe071</button></li>',
				'<li class="pagination-page pagination-page-number" ng-class="{active: tablePaginationController.pagination.currentPage === number}" ng-repeat="number in tablePaginationController.pagination.paginationPageControls">',
				'<button type="button" ng-click="tablePaginationController.changePage(number)">{{number}}</button>',
				'</li>',
				'<li class="pagination-page" ng-class="{disabled: tablePaginationController.pagination.currentPage == tablePaginationController.pagination.totalPages}"><button type="button" ng-disabled="tablePaginationController.pagination.currentPage == tablePaginationController.pagination.totalPages" class="next" ng-click="tablePaginationController.nextPage()">&#xe075</button></li>',
				'<li ng-hide="!tablePaginationController.pagination.boundaryLinks" class="pagination-page"  ng-class="{disabled: tablePaginationController.pagination.currentPage == tablePaginationController.pagination.totalPages}"><button type="button" ng-disabled="tablePaginationController.pagination.currentPage == tablePaginationController.pagination.totalPages" ng-click="tablePaginationController.changePage(tablePaginationController.pagination.totalPages)">&#xe077</button></li>',
				'</ul>',
				'<div>'].join('');

			var navigateToPageTemplate = [
				'<div class="col-xs-12 pagination-navigation hidden-sm hidden-md hidden-lg hidden-xl text-center">',
				'<ul class="pagination pagination-sm">',
				'<li class="pagination-page" ng-class="{disabled: tablePaginationController.pagination.currentPage == 1}"><button type="button" class="previous" ng-click="tablePaginationController.previousPage()">&#xe071</button></li>',
				'<li>',
				'<input type="text" pattern="[0-9]*" ng-model="tablePaginationController.pagination.newInputPage" ng-change="tablePaginationController.changePage(tablePaginationController.pagination.newInputPage)" placeholder="{{\'pagination.jumpTo\' | translate}}"  />',
				'</li>',
				'<li class="pagination-page" ng-class="{disabled: tablePaginationController.pagination.currentPage == tablePaginationController.pagination.totalPages}"><button type="button" class="next" ng-click="tablePaginationController.nextPage()">&#xe075</button></li>',
				'</ul>',
				'<p class="text-center">{{"pagination.paginationLegendMobile" | translate:tablePaginationController.pagination}}</p>',
				'</div>'
			].join('');

			//TODO: Is the data-table-name attribute documented?
			var action = tablePaginationController.tableWrapper.attr('data-table-name');

			var actionDropdownTemplate = [];
			if (action) {
				actionDropdownTemplate = [
					'<div class="col-xs-12 hidden action-dropdown">',
                    '<div class="row">',
						'<div class="col-xs-4 pt-10"><strong>{{"pagination.rowActions" | translate}} :</strong></div>',
							'<div class="col-xs-8">',
								'<select class="form-control inline">',
								'<option>{{"pagination.select" | translate}}</option>',
								'<option>{{"pagination.delete" | translate}}</option>',
								'</select>',
								'<button type="button" class="btn ml-5 mt-neg-3 btn-primary" wc-row-action-multiple="delete-' + action + '">{{"pagination.submit" | translate}}</button>',
							'</div>',
                    	'</div>',
					'</div>'
				].join('');
			}

			var template = [
				'<div class="row">',
				resultsPerPageTemplate,
				paginationLegendTemplate,
				paginationControlsTemplate,
				'</div>',
				'<div class="row">',
				navigateToPageTemplate,
				'</div>',
				'<div class="row">',
				actionDropdownTemplate,
				'</div>',
			].join('');

			var controlsPlacement = tablePaginationController.pagination.paginationControlsPlacement;
			tablePaginationController.createPaginationControlNumbers();

			if(tablePaginationController.pagination.totalItems>0){
				if (controlsPlacement === 'top' || controlsPlacement === 'both') {
					var paginationTop = $compile(template)(scope);
					paginationTop.addClass('pagination-top');
					tablePaginationController.tableWrapper.prepend(paginationTop);
				}
				if (controlsPlacement === 'bottom' || controlsPlacement === 'both') {
					var paginationBottom = $compile(template)(scope);
					paginationBottom.addClass('pagination-bottom');
					tablePaginationController.table.after(paginationBottom);
				}
			}
		}
	};
}]);
